
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component"
import { getProfileList } from "@/api/aio"
import { ConfigCollection } from './json'
import Cell from '../../components/InfoCollection/Cell.vue'
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage } from '@/utils/nativeFn'
import { compareVersion } from "@/utils/compareVersion";

@Options({
  components: {
    Cell
  },
})
export default class InfoCollection extends Vue {
  $store
  infoCollection: any = null 
  isLoading: boolean = true
  queryDone: boolean = false
  clientCommonMessage: object = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
  propertyInfo: object = {id: '6', key: 'userPropertyInfo', label: '用户财产信息', level: '1'}
  mounted() {
    // this.getProfileListFn()
    
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      this.getNativeData()
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroidMsg);
    }
  }
  unmounted(){
    if (!isNewBridgeView()) { 
      window["$eventBus"].removeListener("receiveAndroidMsg", this.receiveAndroidMsg);
    }
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听题目切换
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
          this.getProfileListFn()
        }
      }
    }, 500)
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.queryDone = true
      // 获取到端上数据之后开始调用接口
      this.getProfileListFn()
    })
  }
  // 从端上获取数据
  getNativeData() {
    window['$mobileNativeSDK'].getData((res) => {
      if (!isAndroidApp) {
        this.detailNativeData(res)
      }
    })
  }
  // 安卓监听消息
  receiveAndroidMsg(res) {
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') { // 监听获取数据返回
      this.detailNativeData(androidResult.dataJson)
    }
  }
  // 处理端上数据
  detailNativeData(res) {
    // console.log(res,'---------------detailNativeData-----------------')
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      localStorage.setItem('service_version', res.service_version)
    }
    // 获取到端上数据之后开始调用接口
    this.getProfileListFn()
  }
  async getProfileListFn() {
    // TODO
    // this.isLoading = false
    // this.infoCollection = ConfigCollection.info_collection
    // this.$store.commit('SET_COLLECTIONINFO', ConfigCollection);
    // console.log(ConfigCollection, 'data')
    this.isLoading = true
    await getProfileList({}).then((res) => {
      this.isLoading = false
      if (res.data.code != "0") {
        this.$dialog.alert({
          message: res.data.message,
          confirmButtonText: '我知道了'
        })
        return
      }
      // console.log(res,'result')
      const info = res.data.data
      this.infoCollection = info.info_collection
      // console.log(this.clientCommonMessage)
      
      // if(compareVersion(this.clientCommonMessage["service_version_name"],'1.9.1') === -1){
      //   info.info_collection.splice(1,0,this.propertyInfo)
      // }
      // this.$store.commit('SET_COLLECTIONINFO', info);
    }).catch(() => {
      this.isLoading = false
    })
  }
  
}
